<div class="numero_piezas">{{ numeroSolicitudes }}</div>
<div class="descripcion solicitud-rechazada">DISEÑOS DIGITALES RECHAZADOS</div>
